import {connect} from 'react-redux';

import {makeMapDispatchToProps} from '../../../../helpers/reselectHelpers';
import {IntegrationErrorModel} from '../../../../models/api/integrationErrorModel';
import {dismissIntegrationErrorAction} from '../../../../store/data/localPreferences/localPreferencesActions';
import {navigateToLinkAction} from '../../../../store/stateless/navigationActions';
import {IntegrationErrorBanner} from './integrationErrorBanner';

/*
 * Props.
 */

interface IntegrationErrorBannerContainerProps {
  error: IntegrationErrorModel;
}

/*
 * Component.
 */

const mapDispatchToProps = makeMapDispatchToProps<IntegrationErrorBannerContainerProps>()(({error}) => ({
  onDismissClick: () => dismissIntegrationErrorAction(error.id),
  onLinkClick: () => navigateToLinkAction(`/settings/${error.namespace}/rules`),
}));

export const IntegrationErrorBannerContainer = connect(null, mapDispatchToProps)(IntegrationErrorBanner);
